(function (app, ng) {
    app.config([
        "figModalStateProvider", function (figModalStateProvider) {
            figModalStateProvider.state("Home.ManageAllEntities.TransactionGroup",
                {
                    url: "/{transactionGroupId}",
                    component: "transactionGroupConfigure",
                    requiredPermissions: [{ AccessObject: "TransactionGroupAll", ActionType: "View" }],
                    resolve: {
                        transactionGroup: [
                            "$stateParams", "transactionGroupApi", function ($stateParams, transactionGroupApi) {
                                return transactionGroupApi.get($stateParams.transactionGroupId);
                            }
                        ],
                        publishedTransactionGroup: [
                            "$stateParams", "transactionGroupApi", function ($stateParams, transactionGroupApi) {
                                return transactionGroupApi.getPublishedTransactionGroup($stateParams.transactionGroupId).catch(ng.noop);
                            }
                        ],
                        publishedTransactionGroupQuestionCategories: [
                            "transactionQuestionApi", "transactionGroup", function (transactionQuestionApi, transactionGroup) {
                                return transactionQuestionApi.getPublishedTransactionQuestionCategories(transactionGroup.Id).catch(ng.noop);
                            }
                        ],
                        questionCategories: [
                            "questionApi", "transactionGroup", function (questionApi, transactionGroup) {
                                return questionApi.getQuestionCategories(transactionGroup.Id).catch(ng.noop);
                            }
                        ],
                        stockQuestions: [
                            "stockQuestionApi", function (stockQuestionApi) {
                                return stockQuestionApi.getAllStockQuestions();
                            }
                        ]
                    }
                }, { clickOutsideToClose: false });

            figModalStateProvider.state("Home.Dashboard.TransactionGroup",
                {
                    url: "/TransactionGroup/{transactionGroupId}",
                    component: "transactionGroupConfigure",
                    requiredPermissions: [{ AccessObject: "TransactionGroupOwn", ActionType: "View" }],
                    resolve: {
                        transactionGroup: [
                            "$stateParams", "transactionGroupApi", function ($stateParams, transactionGroupApi) {
                                return transactionGroupApi.get($stateParams.transactionGroupId);
                            }
                        ],
                        publishedTransactionGroup: [
                            "$stateParams", "transactionGroupApi", function ($stateParams, transactionGroupApi) {
                                return transactionGroupApi.getPublishedTransactionGroup($stateParams.transactionGroupId).catch(ng.noop);
                            }
                        ],
                        publishedTransactionGroupQuestionCategories: [
                            "transactionQuestionApi", "transactionGroup", function (transactionQuestionApi, transactionGroup) {
                                return transactionQuestionApi.getPublishedTransactionQuestionCategories(transactionGroup.Id).catch(ng.noop);
                            }
                        ],
                        questionCategories: [
                            "questionApi", "transactionGroup", function (questionApi, transactionGroup) {
                                return questionApi.getQuestionCategories(transactionGroup.Id);
                            }
                        ],
                        stockQuestions: [
                            "stockQuestionApi", function (stockQuestionApi) {
                                return stockQuestionApi.getAllStockQuestions();
                            }
                        ],
                        onEnter: [
                            "$state", "userApi", "transactionGroup", function ($state, userApi, transactionGroup) {
                                return userApi.getUserTransactionGroup().then(function (group) {
                                    if (group.Id !== transactionGroup.Id)
                                        $state.go("Home.Dashboard");
                                });
                            }
                        ]
                    }
                }, { clickoutsidetoclose: false });
        }
    ]);

    app.component("transactionGroupConfigure",
        {
            controller: configureTransactionGroupController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/template.html",
            bindings: {
                transactionGroup: "<",
                publishedTransactionGroup: "<",
                publishedTransactionGroupQuestionCategories: "<",
                questionCategories: "<",
                stockQuestions: "<"
            }
        });

    configureTransactionGroupController.$inject = [
        "$q", "_", "$mdDialog", "businessApi", "laterLoad", "transactionGroupApi",
        "productApi", "transactionGroupProductApi", "transactionQuestionApi", "permissionService", "queueApi"
    ];

    function configureTransactionGroupController($q, _, $mdDialog, businessApi, laterLoad, transactionGroupApi,
        productApi, transactionGroupProductApi, transactionQuestionApi, permissionService, queueApi) {

        var $ctrl = this;

        ng.extend($ctrl,
            {
                permissionService: permissionService,
                UI: {
                    isPublishing: false,
                    isClosing: false,
                    CurrentView: null
                },
                navigateToBasicInfo: navigateToBasicInfo,
                navigateToProducts: navigateToProducts,
                navigateToWorkflows: navigateToWorkflows,
                navigateToForms: navigateToForms,
                close: close,
                publish: publish,
                description: description,
                capturePoints: [],
                determinePoints: [],
                requiredCaptureDocuments: [],
                requiredDetermineDocuments: [],
                capturePointsInfo: [
                    { Name: "Needed Documents", Detail: "Uploads needed to proceed to next step", Value: "NeededDocuments" },
                    { Name: "Households", Value: "Households" },
                    { Name: "Questionnaire", Detail: "Create sections and questions for client", Value: "Questionnaire" },
                    { Name: "Finances", Value: "Finances" },
                    { Name: "Funding", Value: "Funding" }
                ],
                determinePointsInfo: [
                    { Name: "Required Documents", Detail: "Uploads needed to proceed to the next step", Value: "DetermineDocuments" },
                    //TODO: delete this when Righbridge stuff is 100% over
                    //{ Name: "RightBRIDGE", Detail: "Product Comparison Tool", Value: "Rightbridge" },
                    { Name: "RetireUp Pro", Detail: "Retirement Planning Tool", Value: "RetireUp" }
                ],
                disclosePoints: [
                    { Type: "Agent", ShortType: "Agent", Description: "Generated during transaction initiation", IsActive: false },
                    { Type: "Entity", ShortType: "Entity", Description: "Upload the disclosures for your entity", IsActive: false },
                    { Type: "Other Entities", ShortType: "OtherEntities", Description: "Pull disclosures for all entites in workflow", IsActive: false }
                ]
            });

        this.$onInit = function () {
            $ctrl.navigateToBasicInfo();
        };

        function navigateToBasicInfo() {
            var promises = [];

            if ($ctrl.transactionGroup.BusinessId) {
                promises.push(businessApi.get($ctrl.transactionGroup.BusinessId).then(function (response) {
                    $ctrl.transactionGroupBusiness = response;
                }));
            } else {
                $ctrl.transactionGroupBusiness = null;
            }

            //promises.push(businessApi.getArcBusinesses().then(function (response) {
            //    $ctrl.businesses = response;
            //}, function () {
            //    $ctrl.businesses = [];
            //}));

            promises.push(transactionGroupApi.getLogo($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.logo = URL.createObjectURL(response);
            }).catch(ng.noop));

            promises.push(transactionGroupApi.getTransactionGroups($ctrl.transactionGroup.Id).catch(ng.noop));

            $q.all(promises).then(function () {
                $ctrl.UI.CurrentView = 0;
            });
        }

        function navigateToProducts() {
            var promises = [];
            promises.push(productApi.getActiveProducts()
                .then(function (response) {
                    $ctrl.products = response;
                }));
            promises.push(transactionGroupProductApi.getProductsForTransactionGroup($ctrl.transactionGroup.Id)
                .then(function (response) {
                    $ctrl.transactionGroupProducts = response;
                }));
            promises.push(transactionGroupProductApi.getPublishedProducts($ctrl.transactionGroup.Id)
                .then(function (response) {
                    $ctrl.publishedProducts = response;
                }));

            $q.all(promises).then(function () {
                $ctrl.UI.CurrentView = 1;
            });
        }

        function navigateToWorkflows() {
            var promises = [];

            promises.push(transactionGroupApi.getDisclosures($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.disclosures = response;
            }));

            if ($ctrl.transactionGroup.RequiredCaptureDocuments.length !== $ctrl.requiredCaptureDocuments.length) {
                promises.push(ng.forEach($ctrl.transactionGroup.RequiredCaptureDocuments,
                    function (document) {
                        $ctrl.requiredCaptureDocuments.push({ Value: document });
                    }));
            };

            if ($ctrl.transactionGroup.RequiredDetermineDocuments.length !== $ctrl.requiredDetermineDocuments.length) {
                promises.push(
                    ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments,
                        function (document) {
                            if (document.FundingSources.length)
                                document.IsConditional = true;
                            $ctrl.requiredDetermineDocuments.push(document);
                        }));
            };

            $ctrl.capturePoints = [];
            if ($ctrl.transactionGroup.CapturePoints.length) {
                //promises.push(
                ng.forEach($ctrl.transactionGroup.CapturePoints,
                    function (cp) {
                        ng.forEach($ctrl.capturePointsInfo,
                            function (cpi) {
                                if (cpi.Value === cp)
                                    $ctrl.capturePoints.push({ Name: cpi.Name, Detail: cpi.Detail, Value: cp, Type: "point", IsActive: true });
                            });
                    });
            }

            if ($ctrl.transactionGroup.CapturePoints.length !== 6) {
                ng.forEach($ctrl.capturePointsInfo,
                    function (cpi) {
                        if (!$ctrl.transactionGroup.CapturePoints.includes(cpi.Value))
                            $ctrl.capturePoints.push({ Name: cpi.Name, Detail: cpi.Detail, Value: cpi.Value, Type: "point", IsActive: false });
                    });
            }

            $ctrl.determinePoints = [];
            if ($ctrl.transactionGroup.DeterminePoints.length)
                ng.forEach($ctrl.transactionGroup.DeterminePoints,
                    function (dp) {
                        ng.forEach($ctrl.determinePointsInfo,
                            function (dpi) {
                                if (dpi.Value === dp)
                                    $ctrl.determinePoints.push({ Name: dpi.Name, Detail: dpi.Detail, Value: dp, IsActive: true });
                            });
                    });

            if ($ctrl.transactionGroup.DeterminePoints.length !== 6)
                ng.forEach($ctrl.determinePointsInfo,
                    function (dpi) {
                        if (!$ctrl.transactionGroup.DeterminePoints.includes(dpi.Value))
                            $ctrl.determinePoints.push({ Name: dpi.Name, Detail: dpi.Detail, Value: dpi.Value, IsActive: false });
                    });

            $q.all(promises).then(function () {
                $ctrl.UI.CurrentView = 2;
            });
        }

        function navigateToForms() {
            $ctrl.UI.CurrentView = 3;
        }

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.hide();
        }

        function publish($event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to publish this configuration?",
                targetEvent: $event,
                ariaLabel: "Publish Entity Configuration",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                $ctrl.UI.isPublishing = true;
                transactionGroupApi.publish($ctrl.transactionGroup.Id).then(function () {
                    updateUnpublished();
                    $ctrl.UI.isPublishing = false;
                });
            });
        }

        function description(view) {
            switch (view) {
                case 0: return "Basic information about your transaction group";
                case 1: return "Setup the product shelf for you transaction group";
                case 2: return "Manage all the details of your transaction workflow";
                case 3: return "Upload and tag any forms dependent on the transaction";
                default: return "";
            }
        }

        function updateUnpublished() {
            $ctrl.transactionGroup.UnpublishedChanges = null;
            var promises = [];

            function addPromise(collection) {
                var tmpCollection = _.filter(collection, function (c) {
                    return c.Unpublished === true;
                });
                promises.push(ng.forEach(tmpCollection, function (t) {
                    return t.Unpublished = false;
                }));
            }

            promises.push(transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup));

            addPromise($ctrl.disclosures);
            addPromise($ctrl.products);
            addPromise($ctrl.transactionGroupProducts);
            addPromise($ctrl.disclosePoints);
            addPromise($ctrl.requiredCaptureDocuments);
            addPromise($ctrl.capturePoints);
            addPromise($ctrl.questionCategories);
            addPromise($ctrl.determinePoints);
            addPromise($ctrl.requiredDetermineDocuments);
            addPromise($ctrl.queue);
            addPromise($ctrl.users);
            ng.forEach($ctrl.questionCategories, function (category) {
                addPromise(category.QuestionList);
            });

            promises.push(transactionGroupApi.getPublishedTransactionGroup($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.publishedTransactionGroup = response;
            }));
            promises.push(transactionQuestionApi.getPublishedTransactionQuestionCategories($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.publishedTransactionGroupQuestionCategories = response;
            }).catch(ng.noop));

            return $q.all(promises);
        }
    }
})(window.app, window.angular); // jshint ignore:line